import { useEffect, useState } from 'react';

import { type StackedBarDataSet } from 'app/components/chart/types';
import { type DataBar } from 'app/modules/ManagementReport/TaxpayerReport/types';
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
const formatter = new Intl.NumberFormat('ja-JP');

interface Props {
  data: StackedBarDataSet;
}
export const ChartStackedBar = ({ data }: Props) => {
  // https://www.chartjs.org/docs/latest/getting-started/integration.html#bundlers-webpack-rollup-etc
  ChartJS.register(CategoryScale, Title, ArcElement, Tooltip, Legend, LinearScale, BarElement);

  // definicion de todos los colores
  const fondos: Array<string> = [
    '#799351',
    '#22303a',
    '#f2a164',
    '#002d75',
    '#545759',
    '#E7D2CC',
    '#EEEDE7'
  ];

  const bordes: Array<string> = [
    '#303b20',
    '#0e1317',
    '#7e3c0b',
    '#00122f',
    '#222324',
    '#764638',
    '#6e694e'
  ];

  const [state, setState] = useState<DataBar>({
    labels: [],

    datasets: []
  });

  useEffect(() => {
    return setState({
      labels: data.labels,
      datasets: [
        ...data.data.map((x, index) => {
          return {
            label: x.label,
            data: x.data,
            borderWidth: 2,
            backgroundColor: fondos[index],
            borderColor: bordes[index]
          };
        })
      ]
    });
  }, [data]);

  const options = {
    scales: {
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          callback: function (value: any) {
            return formatter.format(value);
          }
        }
      },
      x: {
        stacked: true
      }
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem: any, chart: any) {
          const datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
          return datasetLabel + ': ' + formatter.format(tooltipItem.yLabel);
        }
      }
    }
  };

  return (
    <>
      <Bar data={state} options={options} />
    </>
  );
};

export default ChartStackedBar;
